import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';
import ReactHtmlParser from 'react-html-parser';

import { sanitizeURL } from '../../../../utils';
import TextWithIcon from '../../TextWithIcon';
import Link from '../../../Core/Link';
import RichText from '../../../Core/RichText';
import { Card, Header, Body, Footer } from '../Card/styles';

const body = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <p>{children}</p>,
    [BLOCKS.OL_LIST]: (_, children) => <ol>{children}</ol>,
    [BLOCKS.LIST_ITEM]: (_, children) => <li>{children}</li>,
  },
};

const FAQCategoryCard = ({ data }) => {
  if (!data || !data.imageDam) return null;
  const { category, imageDam, bodyCopy, faqSubCategoryItems } = data;

  return (
    <Card key={category} className="faq-category" role="listitem">
      {(category || imageDam) && (
        <Header>
          {imageDam && category && (
            <TextWithIcon
              type="faq-card"
              icon={imageDam.asset.localImage.publicURL}
            >
              <strong>{category}</strong>
            </TextWithIcon>
          )}
        </Header>
      )}
      {bodyCopy && (
        <Body>
          <RichText document={bodyCopy} options={body} />
        </Body>
      )}
      {faqSubCategoryItems && (
        <Footer>
          {faqSubCategoryItems.map(faqSubCat => {
            return (
              <Link
                key={faqSubCat.id}
                to={`/learning-hub/faqs/${sanitizeURL(
                  faqSubCat.subCatPageSlug,
                )}`}
                ariaLabel={faqSubCat.subCategory}
              >
                {ReactHtmlParser(faqSubCat.subCategory)}
              </Link>
            );
          })}
        </Footer>
      )}
    </Card>
  );
};

FAQCategoryCard.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default FAQCategoryCard;
